import * as React from 'react';
import { Tabs } from '../components';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import PageWrap from './PageWrap';
import { TabObject } from '../utils/types';

type PageWithTabsProps = StyledSystemProps & {
  color?: string;
  children: React.ReactNode;
  tabs: TabObject[];
  renderTabs?: () => TabObject[];
  onTabChange?: () => void;
};

const PageWithTabs: React.FC<PageWithTabsProps> = props => {
  return (
    <PageWrap {...props}>
      <Tabs tabs={props.tabs} renderTabs={props.renderTabs} onClick={() => {
          if (props.onTabChange) {
            props.onTabChange();
          }
          console.log('clicked');
        }}
      />
      {props.children}
    </PageWrap>
  );
};

export default PageWithTabs;

PageWithTabs.defaultProps = {
  tabs: [],
  bg: 'paleGrey',
  children: <div />,
  flexDirection: 'column',
};



// WEBPACK FOOTER //
// ./src/layouts/PageWithTabs.tsx